<template>

    <div class="animateIn">
        <page-builder-part :key="index" :page-part="part" v-for="(part,index) of theContent"></page-builder-part>
    </div>

</template>

<script>
  export default {
    props: ['content'],
    data () {
      return {
        theContent: '',
        page: ''
      }
    },
    created () {
      this.theContent = this.content
      window.api.get('get-pages/' + this.$route.params.project).then(res => {
        this.theContent = res.data.data.content
        this.page = res.data.data.page
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/PageBuilder/PageBuilder.vue